<div class="alert-container" *ngIf="alert" #alertDOM>
  <div *ngIf="alert.type === 'danger'" class="custom-alert-danger">
    <span class="content">
      <span><i class="fa fa-exclamation-triangle"></i></span>
      {{ alert.message }}
      <li *ngIf="alert.additionalMessage">{{alert.additionalMessage}}</li>
    </span>
  </div>
  <div *ngIf="alert.type === 'warning'" class="custom-alert-warning">
    <span class="content">
      <span><i class="fa fa-exclamation-triangle"></i></span>
      {{ alert.message }}
    </span>
  </div>
  <div *ngIf="alert.type === 'info'" class="custom-alert-info">
    <span class="content">
      <span><i class="fa fa-check"></i></span>
      {{ alert.message }}
    </span>
  </div>
  <div *ngIf="alert.type === 'success'" class="custom-alert-success">
    <span class="content">
      <span><i class="fa fa-check"></i></span>
      {{ alert.message }}
      <li *ngIf="alert.additionalMessage">{{alert.additionalMessage}}</li>
    </span>
  </div>
</div>
